import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowPathRight"><Path d="M13 2.7959V7.99967H2V15.9997H13V21.2034L23.5186 11.9997L13 2.7959Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowPathRight;
